<template>
  <section>
    <h3 class="welcome-page__header">Welcome!</h3>
    <p>You are about to experience data collection bliss.</p>
    <p>Our software enables you to aggregate data from multiple sites, label efficiently by skilled physicians, run deep learning code and deploy models in compliance with HIPAA.</p>
  </section>
</template>
<script>
  export default {
    name: 'page-one'
  }
</script>
<style lang="scss" scoped>
.welcome-page {
  &__header {
    margin-top: 0px;
    margin-bottom: 10px;
  }
}
</style>
